export default __webpack_public_path__ + "static/media/Pot1.a769cb3a.svg";